module.exports = __webpack_public_path__ + "static/media/spaceship.2b896f0d.ttf";